import * as React from 'react'
import { CreateInvoiceDetail } from '../InvoiceDetailStore'
import { CreateInvoiceLine, ICompany, InvoiceStatus, IInvoiceLine } from '@getgreenline/homi-shared'
import { CurrencyInput } from '../../../../../components/CurrencyInput'
import { Button, Icon } from 'antd'
import { Currency } from '../../../../../components/Currency'
import { observer } from 'mobx-react'

interface Props {
  company: ICompany
  createInvoice: CreateInvoiceDetail
  line: CreateInvoiceLine | IInvoiceLine
  isOverrideWeightedAverage: boolean
  isOverrideWeightedAverageButtonVisible: boolean
  onEditCompletedCost: (line: CreateInvoiceLine) => void
}

@observer
export class CostTotal extends React.Component<Props> {
  get isEditableCostPerUnitVisible(): boolean {
    const { createInvoice, isOverrideWeightedAverage, company } = this.props

    const isNotCompleted = createInvoice.invoiceDetail?.status !== InvoiceStatus.COMPLETED

    const weightedAverageCase =
      (isNotCompleted || isOverrideWeightedAverage) &&
      company.inventoryCostOption === 'weightedAverage'

    const lastCostCase = company.inventoryCostOption === 'lastCost'

    return weightedAverageCase || lastCostCase
  }

  renderTotalSection = (line: CreateInvoiceLine): JSX.Element => {
    const { isOverrideWeightedAverageButtonVisible, onEditCompletedCost } = this.props

    return (
      <>
        {isOverrideWeightedAverageButtonVisible && (
          <Button onClick={() => onEditCompletedCost(line)}>
            <Currency centValue={line.total} />
            <Icon type='edit' />
          </Button>
        )}

        {this.isEditableCostPerUnitVisible && (
          <CurrencyInput
            className='gr-currency-input'
            centValue={line.total}
            onChange={(value) => {
              line.setTotal(value)
              this.props.createInvoice.setIsEdited(true)
            }}
            onlyPositiveNumber
          />
        )}
      </>
    )
  }

  render() {
    const { createInvoice, line } = this.props

    return createInvoice.isEditMode && line instanceof CreateInvoiceLine ? (
      this.renderTotalSection(line)
    ) : (
      <Currency centValue={line.total} />
    )
  }
}
